import { TripCard } from '../components/TripCard';
import type { AnalysisResult } from '../domain/models';

export function TripsPage({ result }: { result: AnalysisResult }) {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Trip Candidates</h1>
          <p className="page-subtitle">基準地点からの距離、連続日数、通常日より大きい移動距離を組み合わせた候補です。</p>
        </div>
      </header>

      {result.trips.length > 0 ? (
        <div className="trip-list">
          {result.trips.map((trip) => (
            <TripCard key={trip.id} trip={trip} />
          ))}
        </div>
      ) : (
        <div className="surface map-empty">旅行候補は検出されませんでした</div>
      )}
    </div>
  );
}
